module.exports = __webpack_public_path__ + "SushilKonnully-a0426dc8.webp";